ixModuleRouting("impactx.osu", {
    "/osu/:tan": {
        template: "<ixa-osu></ixa-osu>",
        templateUrl: "modules/osu/templates/osu.html",
        controller: "OsuCtrl",
        controllerAs: "osuCtrl",
        noSecurity: true,
    },
    "/validateselfregistrationmail/:tan": {
        templateUrl: "modules/osu/templates/validateselfregistrationmail.html",
        controller: "ValidateSelfRegistrationCtrl",
        controllerAs: "validateSelfRegistrationCtrl",
        noSecurity: true,
    },
    "/approvalentry/:tan/:do/:sender/:direct?": {
        templateUrl: "modules/osu/templates/approvalentry.html",
        controller: "ApprovalEntryCtrl",
        controllerAs: "approvalEntryCtrl",
        noSecurity: true,
    },
    "/osulink/:tan/:token?": {
        templateUrl: "modules/osu/templates/osu.html",
        controller: "OsuLoginCtrl",
        controllerAs: "osuLoginCtrl",
        noSecurity: true,
    },
});
